module.exports = __webpack_public_path__ + "static/media/tiled-blue-card.bdb32cd5.png";